import { useState } from 'react';
import { Body, Button, Col, Row, Stack, SubHeading } from '@workramp/ui';
import { useNavigate } from 'react-router';
import { MixPanel } from '~/common';
import { I18n } from '~/common/explicit-exports';
import { TableEmptyStateContainer } from '../CMSAssetLocationsTable/CMSAssetLocationsTable.styles';
import { CMSAdminMixpanelEvents } from '../../constants';
import { CMSNewAssetModal } from '../CMSNewAssetModal';
import { useGetListAssets } from '../../api';

const { t } = I18n;

const TRANSLATED_EMPTY_TABLE_SUBHEADING = t('js.admin.cms.dashboard_table.empty_description');
const TRANSLATED_EMPTY_TABLE_BODY = t('js.admin.cms.dashboard_table.empty_title');
const TRANSLATED_ADD = t('js.admin.cms.add');

export const CMSDashboardEmptyTable = () => {
  const [CMSNewAssetModalIsOpen, setCMSNewAssetModalIsOpen] = useState(false);
  const { refetch: refetchCMSAssetPickerList } = useGetListAssets();

  const handleNewAssetButtonClick = () => {
    MixPanel.track(CMSAdminMixpanelEvents.ADD_ASSET_CLICKED);
    setCMSNewAssetModalIsOpen(true);
  };

  const navigate = useNavigate();

  return (
    <>
      <TableEmptyStateContainer>
        <Stack size={6}>
          <Row>
            <Col>
              <Stack size={2}>
                <SubHeading level="md">{TRANSLATED_EMPTY_TABLE_SUBHEADING}</SubHeading>
                <Body level="md">{TRANSLATED_EMPTY_TABLE_BODY}</Body>
              </Stack>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                aria-label={TRANSLATED_ADD}
                variant="outline"
                color="secondary"
                size="lg"
                onPress={handleNewAssetButtonClick}
              >
                {TRANSLATED_ADD}
              </Button>
            </Col>
          </Row>
        </Stack>
      </TableEmptyStateContainer>
      <CMSNewAssetModal
        navigate={navigate}
        isOpen={CMSNewAssetModalIsOpen}
        onClose={() => {
          setCMSNewAssetModalIsOpen(false);
        }}
        onSave={(type) => {
          setCMSNewAssetModalIsOpen(false);
          MixPanel.track(CMSAdminMixpanelEvents.ASSET_ADDED, { asset_type: type });
          refetchCMSAssetPickerList();
        }}
      />
    </>
  );
};
